<template>
	<div>
		<div class="search-container">
			<b-form @submit.prevent="filterFiles">
				<b-row>
					<b-col cols="6" sm="2">
						<b-form-group id="fileFormGroup" label="File" label-for="file">
							<b-input id="file" v-model="filter.fileNumber" />
						</b-form-group>
					</b-col>
					<b-col cols="6" sm="2">
        	  <b-form-group label="Status">
        	    <b-form-select v-model="filter.statusId" :options="getStatuses"></b-form-select>
        	  </b-form-group>
        	</b-col>
					<b-col>
						<b-form-group id="initialDateFormGroup" :label="translation.initialDate">
							<b-form-datepicker v-model="filterVisualizationContent.initialCreationDate" :hide-header="true"
								:date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }" placeholder=""
								:required="true" :label-help="null" @context="dateOnContext('initialCreationDate', $event)" reset-button :label-reset-button="translation.reset"></b-form-datepicker>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group id="finalDateFormGroup" :label="translation.finalDate">
							<b-form-datepicker v-model="filterVisualizationContent.finalCreationDate" :min="filterVisualizationContent.initialCreationDate" :hide-header="true"
								:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" placeholder=""
								:required="true"  :label-help="null" @context="dateOnContext('finalCreationDate', $event)" reset-button :label-reset-button="translation.reset"></b-form-datepicker>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12" sm="4">
						<b-form-group id="paxFormGroup" label="Pax" label-for="pax">
							<b-input id="pax" v-model="filter.pax" />
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group id="initialCheckinFormGroup" :label="translation.initialCheckin">
							<b-form-datepicker v-model="filterVisualizationContent.initialCheckin" :hide-header="true"
								:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" placeholder=""
								:required="true" :label-help="null" @context="dateOnContext('initialCheckin', $event)" reset-button></b-form-datepicker>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group id="finalCheckinFormGroup" :label="translation.finalCheckin">
							<b-form-datepicker v-model="filterVisualizationContent.finalCheckin" :min="filterVisualizationContent.initialCheckin" :hide-header="true"
								:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" placeholder=""
								:required="true"  :label-help="null" @context="dateOnContext('finalCheckin', $event)" reset-button></b-form-datepicker>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-button class="search-button" type="submit">{{ translation.search }}</b-button>
					</b-col>
				</b-row>
			</b-form>
		</div>
		<div class="table-container" v-if="files">
			<div class="pagination-box">
				<span>{{ translation.resultsText(totalRows, Math.ceil(totalRows/filter.size)) }}</span>
				<b-pagination
					v-model="filter.page"
					:total-rows="totalRows"
					:per-page="filter.size"
					class="pagination-box"
					pills
				></b-pagination>
			</div>
			<b-table :items="files" :fields="tableFields">
				<template v-slot:cell(activePrice)="data">{{ data.item.currency.symbol + data.item.activePrice }}</template>
				<template v-slot:cell(actions)="data">
					<div class="actions">
						<i class="material-icons" v-b-tooltip.hover :title="translation.seeYourBooking" @click="viewDocument('YOUR_BOOKING', data.item.fileNumber)">file_copy</i>
						<i class="material-icons"  v-b-tooltip.hover :title="translation.voucher" @click="viewDocument('HOTEL_VOUCHER', data.item.fileNumber)" v-if="data.item.status.code == reservationStatus.KK.code">book_online</i>
						<i class="material-icons" v-b-tooltip.hover :title="translation.invoice" @click="viewDocument('INVOICE', data.item.fileNumber)">receipt_long</i>
						<i class="material-icons" v-b-tooltip.hover :title="translation.cancel" @click="cancelFile(data.item.fileNumber)" v-if="canCancel && data.item.status.code != reservationStatus.XL.code">cancel</i>
					</div>
				</template>
				<template #head()="data"> {{ data.field.translation == true ? translation[data.label] : data.label }}</template>
			</b-table>
		</div>
	</div>
</template>
<script>
import moment from 'moment';
import { translate } from '../../assets/translations';
import BookingService from '../../services/BookingService';
import ReservationStatus from '../../enums/ReservationStatus';
import { ReservationDocument } from '../../enums/ReservationDocument';

export default {
	data() {
		return {
			filter: {size: 10, page: 1},
			filterVisualizationContent: {},
			totalRows: 0,
			files: null,
			bookingService: new BookingService(JSON.parse(localStorage.getItem('user'))),
			reservationStatus: ReservationStatus,
			canCancel: JSON.parse(localStorage.getItem('user')).onlineCancellationAllowed,
			tableFields: [
				{
					key: 'fileNumber',
					label:'File',
				},
				{
					key: 'creationDate',
					label: 'date',
					translation: true,
      	  filterByFormatted: true,
					formatter: (value, key, item) => {
      	    return moment(value).format("DD/MM/YYYY hh:mm:ss")
      	  }
				},
				{
					key: 'pax',
					label:'Pax',
				},
				{
					key: 'checkin',
					label: 'checkin',
					translation: true,
      	  filterByFormatted: true,
					formatter: (value, key, item) => {
      	    return moment(value).format("DD/MM/YYYY")
      	  }
				},
				{
					key: 'activePrice',
					label: 'price',
					translation: true,
				},
				{
					key: 'status.code',
					label:'Status',
				},
				{
					key: 'actions',
					label: 'actions',
					translation: true,
				}
			]
		}
	},
	computed: {
		translation() {
			return translate(this.$store.state.language).seeBookings;
		},
    getStatuses() {
      let statuses = [];
      statuses.push({value: undefined, text: '--'});
      statuses = statuses.concat(Object.values(ReservationStatus).filter(status => status.id != ReservationStatus.PD.id).map(status => {return {value: status.id, text: status.code};}));
      return statuses;
    },
	},
	mounted() {
		this.filterFiles();
	},
	methods: {
		filterFiles() {
			this.files = null;
			this.bookingService.filterFiles(this.filter)
			.then(res => {
				this.files = res.data.files;
				this.totalRows = res.data.totalElements;
			});
		},
		dateOnContext(dateField, ctx) {
			this.filter[dateField] = ctx.selectedDate ? ctx.selectedFormatted : null;
		},
		viewDocument(doc, fileOrBookingNumber){
			ReservationDocument[doc]
				.generate
				.call(this.bookingService, fileOrBookingNumber)
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', ReservationDocument[doc].name + ' - ' + fileOrBookingNumber + '.pdf');
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
				.catch(error =>
          this.$store.dispatch("showAlert", {
            message: this.translation.documentErrorMsg + error.response ? error.response.data.message : "",
            code: 0,
            style: "danger"
          })
				);
		},
		cancelFile(fileNumber) {
			if(!confirm(this.translation.cancelConfirmationText(fileNumber))) return;
			this.bookingService.cancelFile(fileNumber)
			.then(res => {
				this.$store.dispatch("showAlert", {
          message: this.translation.cancelSuccessMsg(res.data.fileNumber),
          code: 0,
          style: "success"
        })
				this.filterFiles();
			})
			.catch(error =>
				this.$store.dispatch("showAlert", {
          message: this.translation.cancelFailMsg,
          code: 0,
          style: "danger"
        })
			);
		}
	},
	watch: {
    'filter.page': {
      handler(){
        this.filterFiles();
      }
		}
	}
}
</script>

<style scoped lang="scss">
.search-container {
	background-color: #e8e8e8;
	width: 85%;
	border-radius: 5px;
	margin: 1em auto;
	padding: 0.8em;
	box-shadow: 1px 1px 1px 0px #c3c3c3;
	position: relative;
}

.search-button {
	float: right;
	background-color: #163247;
}

.table-container {
 max-width: 85%;
 margin: 0px auto;
}

.pagination-box {
	display: flex;
  justify-content: space-between;
  align-items: center;
	margin-bottom: 1em;
}

.actions {
	.material-icons {
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/see-your-bookings/SeeYourBookings.vue